import { keccak256, toBytes } from 'viem';

const canon = (o) => JSON.stringify(Object.keys(o).sort().reduce((a, k) => ({ ...a, [k]: o[k] }), {}));
export const hashOf = (o) => keccak256(toBytes(canon(o)));

const BASE_TERMS = [
  { name: 'Item', value: 'Running shoes', origin: 'typed by the person' },
  { name: 'Size', value: "Men's 10", origin: 'typed by the person' },
  { name: 'Color', value: 'Black', origin: 'typed by the person' },
];

export const DELIVERED = { merchant: 'shop.example', orderRef: 'ORD-20077', amountCharged: 10999, currency: 'USD', terms: { Item: 'Running shoes', Size: "Men's 9", Color: 'Black' } };

export function makeIntent(confirmed) {
  const terms = confirmed
    ? BASE_TERMS.map((t) => (t.name === 'Size' ? { name: 'Size', value: "Men's 9", origin: 'proposed by the agent, confirmed by the person on its own' } : t))
    : BASE_TERMS;
  const termsHash = hashOf(Object.fromEntries(terms.map((t) => [t.name, t.value])));
  const intent = { merchant: 'shop.example', agentId: 'agent.example/assistant', intentType: 'single', maxAmount: 12000, currency: 'USD', termsHash, version: confirmed ? 2 : 1 };
  return { terms, intent, digest: hashOf(intent) };
}

export function compare({ terms, intent }) {
  const rows = [
    { field: 'Merchant', asked: intent.merchant, got: DELIVERED.merchant, ok: intent.merchant === DELIVERED.merchant },
    { field: 'Amount', asked: `up to $${(intent.maxAmount / 100).toFixed(2)}`, got: `$${(DELIVERED.amountCharged / 100).toFixed(2)}`, ok: DELIVERED.amountCharged <= intent.maxAmount },
    ...terms.map((t) => ({ field: t.name, asked: t.value, got: DELIVERED.terms[t.name], ok: t.value === DELIVERED.terms[t.name] })),
  ];
  const deliveredHash = hashOf(DELIVERED.terms);
  return { rows, termsMatch: deliveredHash === intent.termsHash, deliveredHash };
}

export const short = (h) => `${h.slice(0, 10)}...${h.slice(-6)}`;
